import React from 'react';
import PropTypes from 'prop-types';
import styles from './ResetPassword.module.scss';
import classNames from 'classnames';
import {
    containsLowerCaseText,
    containsNumberText,
    containsUpperCaseText,
    minLengthText,
    passwordMustContainText
} from './textConsts';

const passSign = '✓';
const failSign = '○';

const uppercaseRegex = /[A-Z]/;
const lowercaseRegex = /[a-z]/;
const numberRegex = /[0-9]/;
const minLengthRegex = /.{6,}/;

export const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{6,}$/;

export const validatePassword = (password) => {
    const hasUpperCase = uppercaseRegex.test(password);
    const hasLowerCase = lowercaseRegex.test(password);
    const hasNumber = numberRegex.test(password);
    const hasMinLength = minLengthRegex.test(password);

    return {
        hasUpperCase,
        hasLowerCase,
        hasNumber,
        hasMinLength,
        allConditionsMet: hasUpperCase && hasLowerCase && hasNumber && hasMinLength
    };
};

export const PasswordConditions = ({ password }) => {
    const { hasUpperCase, hasLowerCase, hasNumber, hasMinLength } = validatePassword(password);

    const conditionClass = (condition) =>
        classNames({
            [styles.condition_met]: condition,
            [styles.condition_not_met]: !condition
        });

    return (
        <div className={styles.password_conditions}>
            <div className={styles.password_info}>{passwordMustContainText}</div>
            <div className={conditionClass(hasUpperCase)}>
                {hasUpperCase ? passSign : failSign} {containsUpperCaseText}
            </div>
            <div className={conditionClass(hasLowerCase)}>
                {hasLowerCase ? passSign : failSign} {containsLowerCaseText}
            </div>
            <div className={conditionClass(hasNumber)}>
                {hasNumber ? passSign : failSign} {containsNumberText}
            </div>
            <div className={conditionClass(hasMinLength)}>
                {hasMinLength ? passSign : failSign} {minLengthText}
            </div>
        </div>
    );
};

PasswordConditions.propTypes = {
    password: PropTypes.string
};
